import { useFormikContext } from 'formik';
import { OfferEligibility, OfferType } from 'legacy/events/types';
import React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import classnames from 'classnames';
import styles from 'legacy/common/components/form/Form.module.scss';

interface UserSelectionProps {
  eligibility: OfferEligibility;
  setUserSelectionModal: ({ id, show }: { id: string; show: boolean }) => void;
  index: number;
}

const UserSelection = ({
  eligibility,
  setUserSelectionModal,
  index
}: UserSelectionProps) => {
  const { errors } = useFormikContext<OfferType>();
  const eligibleUsersCount = eligibility?.users?.length || 0;
  const selectedUserText = eligibility?.users
    ?.slice(0, 2)
    .map((user) => user.name)
    .join(', ');
  const remainingUserText =
    eligibleUsersCount - 2 > 0 ? `... +${eligibleUsersCount - 2} more` : '';
  const totalUserText =
    eligibleUsersCount > 0 ? `${selectedUserText} ${remainingUserText}` : '';

  return (
    <div>
      <div className="relative">
        <div
          className="cursor-pointer"
          onClick={() => {
            setUserSelectionModal({
              id: eligibility.id,
              show: true
            });
          }}
        >
          <input
            type="text"
            id="selectedUsers"
            name="selectedUsers"
            value={totalUserText}
            placeholder="Select Bounce Users..."
            className={classnames(
              'w-full border-1 border-[#DCDCDC] px-4 py-2 mx-auto h-12 rounded-md mt-2',
              {
                [styles.errorField]:
                  errors?.eligibilityCriteria &&
                  errors?.eligibilityCriteria[index]
              }
            )}
            readOnly
          />
          <span
            className={classnames(
              'absolute right-3 top-1/2 transform -translate-y-1/4',
              {
                'top-1/3':
                  errors?.eligibilityCriteria &&
                  errors?.eligibilityCriteria[index]
              }
            )}
          >
            <FaChevronRight className="text-[#B1B1B1] h-4 w-4" />
          </span>
          {errors?.eligibilityCriteria &&
            errors?.eligibilityCriteria[index] && (
              <div className={classnames(styles.error)}>
                {(errors.eligibilityCriteria[index] as any)?.users}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default UserSelection;
